import {checkFeatureFlag} from "@/common/config/websiteConfig";
import useCookieClient from "@hooks/useCookieClient";

const {getCookieClient} = useCookieClient();
export const serverUrl = process.env.RAZZLE_SERVER_URL;
export const apiUrl = process.env.RAZZLE_API_ENDPOINT;
export const apiUrlInternal = process.env.RAZZLE_API_ENDPOINT_INTERNAL || apiUrl;
export const CLIENT_SECRET = process.env.RAZZLE_CLIENT_SECRET;
export const SELECTED_ENV = process.env.RAZZLE_ENV;
export const PHONE_CONTACT_NUMBER_DEFAULT =
    process.env.RAZZLE_PHONE_CONTACT_NUMBER || "+966920005379";

export const PHONE_CONTACT_NUMBER_USED_CARS =
    process.env.RAZZLE_PHONE_CONTACT_NUMBER_USED_CARS || "+966112604715";

export const PHONE_CONTACT_NUMBER_NEW_CARS =
    process.env.RAZZLE_PHONE_CONTACT_NUMBER_NEW_CARS || "+966112604710";

export const WHATSAPP_CONTACT_NUMBER =
    process.env.RAZZLE_WHATSAPP_CONTACT_NUMBER || "+966920005379";
export const CDN_DOMAIN = process.env.RAZZLE_CDN_LINK;
export const CDN_LINK =
    process.env.NODE_ENV !== "production" ? "" : `${CDN_DOMAIN}/${SELECTED_ENV}`;
export const SADAD_MAX_AMOUNT = 250000;
export const SENTRY_DSN = process.env.RAZZLE_SENTRY_SERVER_DSN;
export const SENTRY_CLIENT_DSN = process.env.RAZZLE_SENTRY_CLIENT_DSN;
export const SENTRY_DEBUG = process.env.RAZZLE_SENTRY_DEBUG === "true";
export const BUILD_VERSION = process.env.RAZZLE_BUILD_VERSION;

export const SENTRY_TRACE_SAMPLE_RATE = Number(
    process.env.RAZZLE_SENTRY_TRACE_SAMPLE_RATE || "0.05"
);
export const SENTRY_SAMPLE_RATE = Number(
    process.env.RAZZLE_SENTRY_SAMPLE_RATE || "0.1"
);
export const GROWTHBOOK_CLIENT_KEY = process.env.RAZZLE_GROWTHBOOK_CLIENT_KEY;

// Cloudflare Turnstile. Falls back to Cloudflare's public test key
// (always passes, visible challenge) when no env key is configured.
export const TURNSTILE_SITE_KEY =
    process.env.RAZZLE_TURNSTILE_SITE_KEY || "1x00000000000000000000AA"

export const HEADLESS_CMS_API_BASE_PATH =
    process.env.RAZZLE_HEADLESS_CMS_API_BASE;
export const HEADLESS_CMS_IMAGE_URL =
    process.env.RAZZLE_HEADLESS_CMS_IMAGE_URL.replace("{CDN_LINK}", CDN_DOMAIN).replace('{env}', SELECTED_ENV);
export const HEADLESS_CMS_AUTH_TOKEN = process.env.RAZZLE_HEADLESS_CMS_AUTH_TOKEN;
export const SHOW_DEBUG_INFO = __IS_CSR__ &&
    ['local', 'qa','dev','dev2','preprod'].includes(SELECTED_ENV)
    && getCookieClient('SHOW_DEBUG_INFO') !== 'false';

export const ENABLE_APPOINTMENT_NAVIGATION = checkFeatureFlag("FF_ENABLE_APPOINTMENT_NAVIGATION");
export const LAST_FACET_YEAR = Number(
    process.env.RAZZLE_LAST_FACET_YEAR || (new Date().getFullYear() + 1)
);
export const FACETS_YEARS_COUNT = Number(
    process.env.RAZZLE_FACETS_YEARS_COUNT || "10"
);
export const NOTIFICATIONS_INTEREST_CONFIG = process.env.RAZZLE_NOTIFICATIONS_INTEREST_CONFIG || "3times|3days"

export const SYARAH_V2_JWT_SECRET = process.env.RAZZLE_SYARAH_V2_JWT_SECRET || "34HoxEMmDBNRdB0hltpZuDFzf0fc3RNs";
export const JWT_EXPIRE_TIME_IN_MINUTES = Number(process.env.RAZZLE_JWT_EXPIRE_TIME_IN_MINUTES || "5");

export const GTM_DISABLED = process.env.RAZZLE_GTM_DISABLED === "true";
export const GTM_ID = process.env.RAZZLE_GTM_ID || "GTM-P2RGPR58"; // dev version
export const ENABLE_PING_SECURITY = process.env.RAZZLE_ENABLE_PING_SECURITY === "true";
export const ENABLE_SECURITY_PARAMS = process.env.RAZZLE_ENABLE_SECURITY_PARAMS === "true";
export const SECURE_COOKIE = process.env.RAZZLE_DISABLE_SECURE_COOKIE !== "true";
export const GOOGLE_API_MAP_KEY = process.env.RAZZLE_GOOGLE_MAPS_KEY || 'AIzaSyB6zfaWbBaZAJ4G5ROUxg0zVf-rcOFw6sY';
export const TAMRA_WIDGET_PUBLIC_KEY = process.env.RAZZLE_TAMRA_WIDGET_PUBLIC_KEY || '2bdf2742-ecfc-49cf-b9a0-823a8f492f25';
export const TAMARA_WIDGET_ENVIRONMENT = process.env.RAZZLE_TAMARA_WIDGET_ENV || 'sandbox';
export const TAMRA_WIDGET_URL = process.env.RAZZLE_TAMARA_WIDGET_URL || 'https://cdn-sandbox.tamara.co/widget-v2/tamara-widget.js';
export const CLARITY_KEY = process.env.RAZZLE_CLARITY_KEY || 'u7fcl0fysq';

export const TABBY_WIDGET_PUBLIC_KEY = process.env.RAZZLE_TABBY_WIDGET_PUBLIC_KEY || 'pk_test_019c1934-c130-d184-d703-f772d52e704b';
export const TABBY_WIDGET_MERCHANT_CODE = process.env.RAZZLE_TABBY_WIDGET_MERCHANT_CODE || 'Syasau01';

export const BROKEN_IMAGE_MOBILE = process.env.RAZZLE_MOBILE_IMAGE_BROKEN;
export const BROKEN_IMAGE_DESKTOP = process.env.RAZZLE_DESKTOP_IMAGE_BROKEN;
